import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import {
    Base,
    Container,
    Button,
    Wrapper
}                           from './components';

class NumericPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.min,
        };
    }

    componentDidMount(){
        let { min, value } = this.props;
        let defaultValue = value !== undefined
                                ? value
                                : min;
        this.setState({ 
            value       : defaultValue
        });
    }

    componentDidUpdate(prevProps, _prevState) {
        let { value } = this.props;
        if(prevProps.value !== value) {
            this.setState({ 
                value       : value
            });
        }
    }

    incrementHandler(e) {
        e.persist();
        let { value }   = this.state;
        let { 
            max,
            onChange 
        }               = this.props;
        if(value < max) {
            let newValue    = parseInt(value) + 1;
            this.setState({
                value: newValue,
            }, () => {
                if(typeof onChange === 'function')
                    onChange(newValue);
            });
        }
    }

    decrementHandler(e) {
        e.persist();
        let { value }   = this.state;
        let { 
            onChange 
        }               = this.props;
        let newValue    = parseInt(value) - 1;


        this.setState({
            value: newValue,
        }, () => {
            if(typeof onChange === 'function')
                onChange(newValue);
        });
    }

    onChangeHandler(e) {
        e.persist();
        let value = e.target.value;
        let { min, max, onChange } = this.props;
        if(value !== '' && value >= min && value <= max)
            this.setState({
                value: parseInt(value)
            }, () => {
                if(typeof onChange === 'function')
                    onChange(parseInt(value));
            });
    }

    onClickHandler(e) {
        e.persist();
        let { onClick } = this.props;
        if(!this.isInteractive()) {
            e.stopPropagation();
            return;
        }
        this.refs.HANDLER_INPUT.refs.INPUT.focus();
        if(onClick)
            onClick();
    }

    createComponentClasses() {
        let {
            className,
        } = this.props;

        let classNames      = [ 'marketkit-numeric-picker' ];
        if (className)      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render() {
        let { value } = this.state;
        let { 
            max,
            min,
            attrs,
        } = this.props;
        return (
            <Container className   = { this.createComponentClasses() } >
                <Wrapper>
                    <Button 
                        icon        = { "solid-minus" }
                        active      = { !value > min }
                        onClick     = { (e) => this.decrementHandler(e) }
                    />
                    <Base 
                        max         = { max }
                        min         = { min }
                        value       = { value }
                        onChange    = { (e) => this.onChangeHandler(e) }
                        attrs       = { attrs }
                    />
                    <Button 
                        icon        = { "solid-plus" }
                        active      = { value < max }
                        onClick     = { (e) => this.incrementHandler(e) }
                    />
                </Wrapper>
            </Container>
        )
    }
}

NumericPicker.propTypes = {
    onChange        : PropTypes.func,
    attrs           : PropTypes.object,
    min             : PropTypes.number,
    max             : PropTypes.number,
};

NumericPicker.defaultProps = {
    onChange        : () => {},
    attrs           : {},
    min             : 0,
    max             : 10,
};

export default NumericPicker;